var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('ja-form',_vm._g({ref:"jaForm",attrs:{"rules":{},"noButton":true,"formArray":_vm.rowFormData},model:{value:(_vm.rowForm),callback:function ($$v) {_vm.rowForm=$$v},expression:"rowForm"}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }